
$(function () {
    if ($('.jvz-textarea-count').length) {
        var $jvzTa = $('.jvz-textarea-count');
        var $counterContainer = $jvzTa.next('.jvz-textarea-counter');
        var $counter = $counterContainer.children('span');
        var maxChar = $jvzTa.attr('maxlength');
        var baseColor = $jvzTa.css('color');

        $counter.text(maxChar - $jvzTa.val().length);
        jvzTextAreaCountColor($jvzTa, maxChar, $counterContainer);
        //jvzTextAreaCountColor($jvzTa, maxChar, baseColor);

        $jvzTa.keydown(function(){
            $counter.text(maxChar - $jvzTa.val().length);
            jvzTextAreaCountColor($jvzTa, maxChar, $counterContainer);
            //jvzTextAreaCountColor($jvzTa, maxChar, baseColor);
        });
    }
})



function jvzTextAreaCountColor($txtArea, maxCount, $counterContainer) {

    var warnLevel = maxCount * .12;
    var dangerLevel = maxCount * .05;
    var curRemaining = maxCount - $txtArea.val().length;

    if (curRemaining <= dangerLevel) {
        $counterContainer.addClass('bg-danger white').removeClass('bg-warning');
    } else if (curRemaining <= warnLevel) {
        $counterContainer.addClass('bg-warning white').removeClass('bg-danger');
    } else {
        $counterContainer.removeClass('bg-warning bg-danger white');
    }
}



// function jvzTextAreaCountColor($txtArea, maxCount, baseColor) {
//
//     $txtArea.css('color', function() {
//
//         var warnLevel = maxCount * .12;
//         var dangerLevel = maxCount * .05;
//         var curRemaining = maxCount - $txtArea.val().length;
//         var setColor = baseColor;
//
//         if (curRemaining <= dangerLevel) {
//             setColor = '#ee3725';
//         } else if (curRemaining <= warnLevel) {
//             setColor = '#f5af01';
//         }
//
//         return setColor;
//     });
// }